module.exports = __webpack_public_path__ + "img/03.f0075dc4.png";